/* eslint-disable */
import React from 'react';
import { oneOfType, arrayOf, element, string } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

import classnames from 'classnames/bind';

const MarketingOffers = ({ children, customRenderId, title, id: entryId }) => {
  const isB2BVariant = customRenderId === 'B2B Marketing Gallery';

  const gridColumns = isB2BVariant
    ? 'sui-grid sui-gap-5 sui-grid-cols-1 sm:sui-grid-cols-3'
    : classnames({
        'sui-grid sui-gap-5 sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-4':
          children.length >= 4,
        'sui-grid sui-gap-5 sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-3':
          children.length === 3,
        'sui-grid sui-gap-5 sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-2':
          children.length === 2,
        'sui-grid sui-gap-5 sui-grid-cols-1 sm:sui-grid-cols-1 md:sui-grid-cols-1':
          children.length <= 1,
      });

  return (
    <div
      id={`${isB2BVariant ? 'b2b-' : ''}marketing-gallery-php-${entryId}`}
      className="sui-h-full"
    >
      <ImpressionProvider
        data={{
          id: entryId,
          name: 'Section',
          component: 'Section',
          type: 'content',
          position: '',
        }}
      >
        <QueryProvider
          cacheKey={`${isB2BVariant ? 'b2b-' : ''}marketing-gallery`}
        >
          {title && (
            <div className="sui-my-4">
              <Typography variant="h2" height="snug" color="primary" uppercase>
                {title}
              </Typography>
            </div>
          )}
          <div className={gridColumns}>
            {children.map((child, index) => <React.Fragment key={index}>{child}</React.Fragment>)}
            </div>
        </QueryProvider>
      </ImpressionProvider>
    </div>
  );
};

MarketingOffers.propTypes = {
  children: oneOfType([element, arrayOf(element)]), // eslint-disable-line
  mcvisID: string,
  title: string,
  id: string,
};

MarketingOffers.defaultProps = {
  children: null,
  mcvisID: null,
  title: null,
  id: null,
};

export { MarketingOffers };
